import { useEffect } from 'react';

import { usePostUserAlbums } from '@vimeo/gctl-api/hooks/useUserAlbums';
import { translate } from '@vimeo/i18n-runtime';

const DEFAULT_SHOWCASE_NAME = translate('Untitled showcase');

interface Params {
  onFailure?: () => void;
  onSuccess?: (data: { uri: string }) => void;
  /**
   * Id of user whose account the showcase will be created on
   */
  teamOwnerId?: number;
}

/**
 * Hook to create an empty showcase.
 */
export const useCreateShowcase = ({ onFailure, onSuccess, teamOwnerId }: Params) => {
  const [post, { called, data, error, loading }] = usePostUserAlbums();

  useEffect(() => {
    if (!called || loading) return;

    if (data) {
      onSuccess?.({ uri: data.uri });
    }

    if (error) {
      onFailure?.();
    }
  }, [called, data, error, loading, onFailure, onSuccess]);

  const create = () => {
    if (!teamOwnerId) return;
    post({
      where: {
        userId: teamOwnerId,
      },
      select: ['uri'],
      variables: {
        name: DEFAULT_SHOWCASE_NAME,
      },
    });
  };

  return [create, { loading }] as const;
};
